import { css, breakpoint } from 'bumbag';
import { _ as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';

var _templateObject, _templateObject2;
var Toast = {
  placement: 'top',
  defaultProps: {
    accent: 'bottom',
    variant: 'tint'
  },
  styles: {
    base: function base(props) {
      return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      border-radius: 0px;\n      width: 480px;\n\n      ", "\n    "])), breakpoint('mobile', css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n          width: 90vw;\n        "]))))(props));
    }
  }
};

export default Toast;
